function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Tracciato 4757",
  fill: "#121212"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5 12.5c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 1A5.506 5.506 0 001 6.5C1 9.533 3.467 12 6.5 12S12 9.533 12 6.5 9.533 1 6.5 1m0-1a6.5 6.5 0 110 13 6.5 6.5 0 010-13z",
  fill: "#007D39"
}));

function SvgPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13
  }, props), _ref);
}

export default SvgPosition;